import { render, staticRenderFns } from "./NewPatientForm.vue?vue&type=template&id=372f8605&"
import script from "./NewPatientForm.vue?vue&type=script&lang=js&"
export * from "./NewPatientForm.vue?vue&type=script&lang=js&"
import style0 from "./NewPatientForm.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports